// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"81":"bc78bc6b","128":"11f1f478","291":"20c4354b","347":"602eba93","578":"00c6fcb7","639":"545a15a2","757":"20c4354b","947":"545a15a2","965":"11f1f478"}[chunkId] + ".chunk.css";
};